var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 16.0001C29.3332 23.3601 23.3598 29.3334 15.9998 29.3334C8.63984 29.3334 4.1465 21.9201 4.1465 21.9201M4.1465 21.9201H10.1732M4.1465 21.9201V28.5867M2.6665 16.0001C2.6665 8.64008 8.5865 2.66675 15.9998 2.66675C24.8932 2.66675 29.3332 10.0801 29.3332 10.0801M29.3332 10.0801V3.41341M29.3332 10.0801H23.4132",
    stroke: "#276E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9463 20.2401L16.813 17.7734C16.093 17.3468 15.5063 16.3201 15.5063 15.4801V10.0134",
    stroke: "#276E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/Repeat.f2288be2da0790bf7cec3a050574976b.svg";
export { ForwardRef as ReactComponent };